<template>
  <div
    class="container v-content-container tooltip-wrapper"
    :key="componentKey"
  >
    <div class="row tooltip-wrapper">
      <div class="col-xs-12">
        <h1>
          <i class="fa fa-user fa-fw fa-lg"></i>
          {{ $label("customer.customers", "Customers") }}
          <router-link
            :to="{ name: 'NewCustomer' }"
            v-tooltip="{
              content: $label('customer.new_customer', 'New customer'),
              classes: 'custom-tooltip'
            }"
            class="btn btn-v-lightgreen-white pull-right"
          >
            <i class="fa fa-fw fa-lg fa-plus"></i>
          </router-link>

          <a
            id="display-all"
            v-tooltip="{
              content: $label(
                'customer.show_also_customers_who_have_not_agreed_to_be_contacted',
                'Show also customers who have not agreed to be contacted'
              ),
              classes: 'custom-tooltip'
            }"
            class="btn btn-primary pull-right"
            href="/customers/new/"
          >
            {{ $label("customer.show_all", "Show all") }}
          </a>
          <select
            id="customer-group-select"
            class="form-control header-select pull-right"
            style="margin-right: 15px;"
          >
            <option value="">{{ $label("customer.groups", "Groups") }}</option>
            <option value="groupId">Groupname</option>
          </select>
        </h1>
      </div>
    </div>
    <input type="hidden" id="customer-display-all" value="false" />

    <div id="customers-warning" class="row hidden">
      <div class="col-xs-12">
        <alert-box type="danger" :closeable="false" :show-icon="true">
          <b>{{ $label("common.attention", "Attention") }}:</b>
          {{
            $label(
              "customer.alert_balance",
              "Use of this data for marketing purposes according to DSGVO not allowed"
            )
          }}
        </alert-box>
      </div>
    </div>

    <alert-box
      v-show="failedRequest"
      type="warning"
      :closeable="false"
      :show-icon="false"
    >
      {{
        $label(
          "customer.customers_failed_request",
          "Request failed while loading customers."
        )
      }}
    </alert-box>

    <div
      class="modal fade tooltip-wrapper"
      id="exportCustomersModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exportCustomersModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <form
            id="exportCustomersForm"
            action="/customers/all/export/"
            method="post"
          >
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-hidden="true"
              >
                &times;
              </button>
              <h4 class="modal-title" id="exportCustomersModalLabel">
                <i class="fa fa-fw fa-lg fa-cloud-download text-primary"></i>
                {{
                  $label(
                    "customer.export_customer_data",
                    "Export customer data"
                  )
                }}
              </h4>
            </div>

            <div class="modal-body">
              <p>
                Export der Kundendaten als CSV - bitte an die Vorgaben nach
                DSGVO bei der weiteren Verarbeitung der Daten halten.<br /><br />
              </p>

              <div class="v-form v-form-borderless">
                <fieldset>
                  <div class="row">
                    <label class="checkbox">
                      <input
                        type="checkbox"
                        name="with_membership_data"
                        id="withMembershipData"
                        value="true"
                      />{{
                        $label(
                          "customer.including_membership_information",
                          "Inlcuding membership information"
                        )
                      }}<i></i>
                    </label>
                  </div>
                </fieldset>
              </div>
              <div class="v-form v-form-borderless">
                <fieldset>
                  <div class="row">
                    <label class="checkbox">
                      <input
                        type="checkbox"
                        name="full_export"
                        id="fullExport"
                        value="true"
                      />{{
                        $label(
                          "customer.including_customers_who_do_not_wish_marketing_contact",
                          "Inlcuding customers who do not wish marketing contact"
                        )
                      }}<i></i>
                    </label>
                  </div>
                </fieldset>
              </div>

              <div id="fullExportWarning" class="hide">
                <div>&nbsp;</div>
                <alert-box
                  v-show="customersLength < 1 && customersLength != null"
                  type="danger"
                  id="alert-no-customer"
                  :closeable="false"
                  :show-icon="false"
                >
                  <b>{{ $label("common.gdpr_note", "GDPR note") }}:</b>
                  {{
                    $label(
                      "customer.alert_gdpr",
                      "The export also contains sensitive data of customers who have not expressly agreed to its use for marketing purposes."
                    )
                  }}
                </alert-box>
              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-default"
              >
                <i class="fa fa-fw fa-undo"></i>
                {{ $label("common.cancel", "Cancel") }}
              </button>
              <button class="btn btn-primary" type="submit">
                <i class="fa fa-fw fa-cloud-download"></i>
                {{ $label("customer.export_now", "Export now") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="searchModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="searchModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              &times;
            </button>
            <h4 class="modal-title" id="searchModalLabel">
              <i class="fa fa-fw fa-lg fa-search-plus text-primary"></i>
              {{ $label("customer.advanced_search", "Advanced search") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row well">
              <div class="col-xs-5">
                <label class="input">{{
                  $label("customer.bookings_since", "Bookings since")
                }}</label>
                <date-picker
                  v-model="bookingsSinceDate"
                  :format="dateFormat"
                  class="input"
                  placeholder="Since"
                ></date-picker>
              </div>
              <div class="col-xs-1"></div>
              <div class="col-xs-6">
                <label id="amount" class="input">
                  {{ $label("common.between", "Between") }}
                  {{ extSearchSlider.value[0] }}
                  {{ $label("common.and", "and") }}
                  {{ extSearchSlider.value[1] }}
                  {{ $label("common.bookings", "bookings") }}
                </label>
                <vue-slider
                  ref="slider"
                  v-model="extSearchSlider.value"
                  v-bind="extSearchSlider.options"
                ></vue-slider>
                <div id="slider-range"></div>
                <input type="hidden" id="minBookings" value="0" />
                <input type="hidden" id="maxBookings" value="200" />
              </div>
            </div>

            <div class="row">
              <div class="col-xs-6" style="padding-left: 35px;">
                <!-- BEGIN Customer type -->
                <label class="input font-bold typo__label">{{
                  $label(
                    "customer.belongs_to_organization",
                    "Belongs to organization"
                  )
                }}</label>
                <multiselect
                  v-model="customerTypeValue"
                  tag-placeholder=""
                  placeholder="Add customer type"
                  label="name"
                  track-by="id"
                  :options="customerTypeOptions"
                  class="v-multiselect v-form"
                  :multiple="true"
                  :taggable="false"
                  :show-labels="false"
                  :close-on-select="true"
                  @tag="addCustomerType"
                >
                </multiselect>
                <!-- END Customer type -->
              </div>

              <div class="col-xs-6" style="padding-right: 35px;">
                <!-- BEGIN Not customer type -->
                <label class="input font-bold typo__label">{{
                  $label(
                    "customer.does_not_belong_to_organization",
                    "Does not belong to organization"
                  )
                }}</label>
                <multiselect
                  v-model="notCustomerTypeValue"
                  tag-placeholder=""
                  placeholder="Add customer type"
                  label="name"
                  track-by="id"
                  :options="notCustomerTypeOptions"
                  class="v-multiselect v-form"
                  :multiple="true"
                  :taggable="false"
                  :show-labels="false"
                  :close-on-select="true"
                  @tag="addNotCustomerType"
                >
                </multiselect>
                <!-- END Not customer type -->
              </div>
            </div>

            <div class="row mb-8"><div class="col-xs-12">&nbsp;</div></div>

            <div class="row well">
              <div class="col-xs-6">
                <!-- BEGIN Customer group -->
                <label class="input font-bold typo__label">{{
                  $label(
                    "customer.belongs_to_customer_group",
                    "Belongs to customer group"
                  )
                }}</label>
                <multiselect
                  v-model="customerGroupValue"
                  tag-placeholder=""
                  placeholder="Add customer group"
                  label="name"
                  track-by="id"
                  :options="customerGroupOptions"
                  class="v-multiselect v-form"
                  :multiple="true"
                  :taggable="false"
                  :show-labels="false"
                  :close-on-select="true"
                  @tag="addCustomerGroup"
                >
                </multiselect>
                <!-- END Customer group -->
              </div>
              <div class="col-xs-6">
                <!-- BEGIN Not customer group -->
                <label class="input font-bold typo__label">{{
                  $label(
                    "customer.does_not_belong_to_customer_group",
                    "Does not belong to customer group"
                  )
                }}</label>
                <multiselect
                  v-model="notCustomerGroupValue"
                  tag-placeholder=""
                  placeholder="Add customer group"
                  label="name"
                  track-by="id"
                  :options="notCustomerGroupOptions"
                  class="v-multiselect v-form"
                  :multiple="true"
                  :taggable="false"
                  :show-labels="false"
                  :close-on-select="true"
                  @tag="addNotCustomerGroup"
                >
                </multiselect>
                <!-- END Not customer group -->
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              data-dismiss="modal"
              id="reset-filter"
              class="btn btn-default"
              @click="resetExtendedSearch"
            >
              <i class="fa fa-fw fa-undo"></i>
              {{ $label("common.reset", "Reset") }}
            </button>
            <button
              type="button"
              data-dismiss="modal"
              id="submit-filter"
              class="btn btn-primary"
            >
              <i class="fa fa-fw fa-search"></i>
              {{ $label("common.confirm", "Confirm") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->

    <Table
      v-show="!failedRequest"
      id="customers-table"
      :loading="loading"
      :columns="[
        {
          title: 'Customer number',
          field: 'number',
          id: row => `customer-number-${row.id}`,
          onClick: row =>
            $router.push({
              name: 'CustomerData',
              params: { customer_id: row.id }
            })
        },
        {
          title: 'Customer',
          id: row => `customer-name-${row.id}`,
          value: row => beautifyName(row.first_name, row.last_name),
          onClick: row =>
            $router.push({
              name: 'CustomerData',
              params: { customer_id: row.id }
            }),
          tooltip: row =>
            '<div class=&quot;tooltip-title-background&quot;><p class=&quot;tooltip-title&quot;><i class=&quot;text-primary fa fa-lg fa-fw fa-info-circle&quot;></i><b>' +
            'Groups' +
            '</b></p></div>' +
            '<p class=&quot;tooltip-content&quot;>' +
            'No assignment existing' +
            '</p>'
        },
        {
          title: 'Type',
          id: row => `customer-type-${row.id}`,
          value: row => 'Privat'
        },
        {
          title: 'Phone number',
          id: row => `customer-phone-number-${row.id}`,
          tooltip: row =>
            '<div class=&quot;tooltip-title-background&quot;><p class=&quot;tooltip-title&quot;><i class=&quot;text-primary fa fa-lg fa-fw fa-user&quot;></i> <b>' +
            (Boolean(row.first_name && row.first_name)
              ? beautifyName(row.first_name, row.first_name)
              : '') +
            '</b></p></div>' +
            '<i class=&quot;text-v-green fa  fa-lg fa-fw fa-mobile&quot;></i>' +
            (Boolean(
              row.phone_number &&
                row.phone_number.prefix &&
                row.phone_number.number
            )
              ? `+${row.phone_number.prefix}${row.phone_number.number}`
              : '') +
            '<br><i class=&quot;text-v-green fa fa-lg fa-fw fa-phone&quot;></i> <br><i class=&quot;text-v-green fa fa-lg fa-fw fa-tag&quot;></i> ',
          icon: row =>
            Boolean(
              row.phone_number &&
                row.phone_number.prefix &&
                row.phone_number.number
            )
              ? 'mobile'
              : null,
          value: row =>
            Boolean(
              row.phone_number &&
                row.phone_number.prefix &&
                row.phone_number.number
            )
              ? `+${row.phone_number.prefix}${row.phone_number.number}`
              : '-'
        },
        {
          title: 'Email',
          field: 'email',
          id: row => `customer-email-${row.id}`
        }
      ]"
      :actions="[
        {
          type: 'detail',
          onClick: row => {
            $router.push({
              name: 'CustomerData',
              params: { customer_id: row.id }
            });
          }
        },
        {
          icon: 'envelope-o',
          bgColor: 'primary',
          tooltip: 'Email to this customer',
          onClick: () => {
            $router.push('/settings/users/id/message/');
          }
        },
        {
          icon: 'mobile',
          bgColor: 'primary',
          tooltip: 'SMS to this customer',
          onClick: () => {
            $router.push('/customers/id/message/sms/');
          }
        }
      ]"
      :data="customers"
      :meta="metaData"
      selectable
      @onRowSelect="() => {}"
      @fetchQuery="
        params => {
          fetchParams = params;
          getCustomers({
            //
          });
        }
      "
    >
      <div
        id="action-dropdown"
        slot="toolbar"
        class="btn-group"
        style="margin-left: 5px;"
      >
        <button
          type="button"
          class="btn btn-primary dropdown-toggle"
          data-toggle="dropdown"
        >
          <i class="fa fa-refresh"></i> &nbsp;
          {{ $label("common.actions", "Actions") }} &nbsp;<span
            class="caret"
          ></span>
        </button>
        <ul class="dropdown-menu" role="menu">
          <li>
            <router-link :to="{ name: 'NewCustomer' }"
              ><i class="text-primary fa fa-fw fa-lg fa-plus"></i>
              {{
                $label("customer.create_new_customer", "Create new customer")
              }}</router-link
            >
          </li>
          <li role="presentation" class="divider"></li>
          <li>
            <a href="#" id="email-selected-customers"
              ><i class="text-primary fa fa-fw fa-lg fa-envelope-o"></i>
              {{
                $label(
                  "customer.email_to_selected_customers",
                  "Email to selected customers"
                )
              }}</a
            >
          </li>
          <li>
            <a href="/customers/all/message/email/"
              ><i class="text-primary fa fa-fw fa-lg fa-envelope-o"></i>
              {{
                $label(
                  "customer.email_to_all_customers",
                  "Email to ALL customers"
                )
              }}</a
            >
          </li>
          <li role="presentation" class="divider"></li>
          <li>
            <a href="#" id="sms-selected-customers"
              ><i class="text-primary fa fa-fw fa-lg fa-mobile"></i>
              {{
                $label(
                  "customer.sms_to_selected_customers",
                  "SMS to selected customers"
                )
              }}</a
            >
          </li>
          <li>
            <a href="/customers/all/message/sms/"
              ><i class="text-primary fa fa-fw fa-lg fa-mobile"></i>
              {{
                $label("customer.sms_to_all_customers", "SMS to ALL customers")
              }}</a
            >
          </li>
          <li role="presentation" class="divider"></li>
          <li>
            <a href="#" id="exportCustomerBtn"
              ><i class="text-primary fa fa-fw fa-lg fa-cloud-download"></i>
              {{ $label("customer.all_customers", "All customers") }}</a
            >
          </li>
          <li>
            <a href="#" class="" disabled
              ><i class="text-primary fa fa-fw fa-lg fa-cloud-download"></i>
              {{
                $label("customer.export_all_customers", "Export all customers")
              }}</a
            >
          </li>
        </ul>
      </div>

      <button
        slot="ext-search-button"
        class="btn btn-success customer-search-button"
        v-tooltip="{
          content: $label(
            'customer.more_search_filters',
            'More search filters'
          ),
          classes: 'custom-tooltip'
        }"
        type="button"
        data-toggle="modal"
        data-target="#searchModal"
      >
        <i class="fa fa-fw fa-lg fa-search-plus"></i>
      </button>
    </Table>

    <div class="row mb-8">
      <div class="col-xs-12">&nbsp;</div>
    </div>
  </div>
</template>

<script>
import Api from "@/api";
import Table from "@/components/Common/Table";
import AlertBox from "@/components/Common/Alerts/AlertBox";

import swal from "sweetalert";
import Multiselect from "vue-multiselect";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/de";

export default {
  name: "CustomersOverview",

  components: {
    AlertBox,
    Table,
    Multiselect,
    VueSlider,
    DatePicker
  },

  data() {
    return {
      componentKey: 0,
      customers: [],
      customersLength: null,
      loading: false,
      updating: false,
      failedRequest: false,
      metaData: null,
      fetchParams: {
        page: 1,
        per_page: null,
        search: ""
      },
      selectedCustomerId: null,
      bookingsSinceDate: null,
      dateFormat: "DD.MM.YYYY",
      extSearchSlider: {
        value: [0, 200],
        options: {
          dotSize: 14,
          width: "auto",
          height: 4,
          contained: false,
          direction: "ltr",
          data: null,
          dataLabel: "label",
          dataValue: "value",
          min: 0,
          max: 500,
          interval: 1,
          disabled: false,
          clickable: true,
          duration: 0.3,
          adsorb: false,
          lazy: false,
          tooltip: "none",
          tooltipPlacement: "top"
        }
      },
      customerTypeValue: [
        //
      ],
      customerTypeOptions: [
        { name: "Privat", id: 1 },
        { name: "Firma", id: 2 },
        { name: "Verein", id: 3 },
        { name: "Kindergarten", id: 4 },
        { name: "Schule", id: 5 },
        { name: "Hobby", id: 6 }
      ],
      notCustomerTypeValue: [
        //
      ],
      notCustomerTypeOptions: [
        { name: "Privat", id: 1 },
        { name: "Firma", id: 2 },
        { name: "Verein", id: 3 },
        { name: "Kindergarten", id: 4 },
        { name: "Schule", id: 5 },
        { name: "Hobby", id: 6 }
      ],
      customerGroupValue: [
        //
      ],
      customerGroupOptions: [{ name: "Mitglieder", id: 1 }],
      notCustomerGroupValue: [
        //
      ],
      notCustomerGroupOptions: [{ name: "Mitglieder", id: 1 }]
    };
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (
        vm.$route.query.customer_deleted === true ||
        vm.$route.query.customer_deleted === "true"
      ) {
        swal("Success!", "The customer was deleted.", "success").then(() => {
          window.history.pushState(
            {},
            document.title,
            window.location.pathname
          );
        });
      }
      vm.getCustomers(() => {
        //
      });
    });
  },

  beforeRouteUpdate(to, from, next) {
    if (to.query.customer_deleted === true) {
      swal("Success!", "The customer was deleted.", "success").then(() => {
        window.history.pushState({}, document.title, window.location.pathname);
      });
    }
    this.forceRerender();
    if (
      this.fetchParams.to % this.fetchParams.per_page === 0 &&
      this.fetchParams.page !== 1
    ) {
      this.fetchParams.page -= 1;
    }
    this.getCustomers(() => {
      //
    });
    next();
  },

  mounted() {
    //
  },

  methods: {
    addCustomerType(customerType) {
      this.customerTypeValue.push(customerType);
    },

    addNotCustomerType(notCustomerType) {
      this.notCustomerTypeValue.push(notCustomerType);
    },

    addCustomerGroup(customerGroup) {
      this.customerGroupValue.push(customerGroup);
    },

    addNotCustomerGroup(notCustomerGroup) {
      this.notCustomerGroupValue.push(notCustomerGroup);
    },

    resetExtendedSearch() {
      this.customerTypeValue = [];
      this.notCustomerTypeValue = [];
      this.customerGroupValue = [];
      this.notCustomerGroupValue = [];
      this.extSearchSlider.value = [0, 200];
      this.bookingsSinceDate = null;
    },

    getCustomers(successCallback) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      this.customers = [];
      const endpoint = this.$partnerEndpoint("customers");

      Api()
        .get(endpoint, {
          params: {
            page: this.fetchParams.page,
            search: this.fetchParams.search
          }
        })
        .then(response => {
          this.customers = response.data.data;
          this.metaData = response.data.meta;
          this.customersLength = response.data.data.length;
          this.failedRequest = false;
          if (typeof successCallback == "function") {
            successCallback();
          }
        })
        .catch(() => {
          this.failedRequest = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    forceRerender() {
      this.componentKey += 1;
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.mt-0 {
  margin-top: 0rem;
}

.mt-8 {
  margin-top: 1.3rem;
}

.mb-0 {
  margin-bottom: 0rem;
}

.mb-1 {
  margin-bottom: 0.3rem;
}

.mb-2 {
  margin-bottom: 0.6rem;
}

.mb-8 {
  margin-bottom: 1.3rem;
}

.checkbox-fixed-width {
  width: 50px;
}

.v-table-checkbox-label {
  margin-left: 10px;
}

.v-table-checkbox {
  position: relative !important;
}

.min-width-auto {
  width: 50px;
}

.customer-search-input {
  width: 60% !important;
  display: inline;
}

.customer-search-button {
  margin-bottom: 4px;
  padding: 5px 12px;
  margin-left: 5px;
}
</style>
